import React, { useMemo } from "react";
import { Form, Pagination } from "react-bootstrap";
import "./index.css"; // reuse your existing styles

const CustomPagination = ({
  currentPage,
  totalPages,
  loading,
  onPageChange,
  perPageOptions,
  pageSize,
  setPageSize,
  setCurrentPage,
  total,
  className,
}) => {
  const pageItems = useMemo(() => {
    const items = [];
    const maxButtons = 7;
    const add = (n) =>
      items.push(
        <Pagination.Item
          key={n}
          active={n === currentPage}
          onClick={() => onPageChange(n)}
          className="custom-pagination-item"
        >
          {n}
        </Pagination.Item>
      );

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) add(i);
      return items;
    }

    const windowSize = 3;
    const left = Math.max(2, currentPage - windowSize);
    const right = Math.min(totalPages - 1, currentPage + windowSize);

    add(1);
    if (left > 2) items.push(<Pagination.Ellipsis key="l-ell" disabled />);
    for (let i = left; i <= right; i++) add(i);
    if (right < totalPages - 1)
      items.push(<Pagination.Ellipsis key="r-ell" disabled />);
    add(totalPages);

    return items;
  }, [currentPage, totalPages, onPageChange]);
  // display range like "11–20 of 137"
  const startIndex = total === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endIndex = total === 0 ? 0 : Math.min(currentPage * pageSize, total);
  return (
    <div
      className={`d-flex align-items-center gap-2 justify-content-between p-2 bg-white ${className}`}
    >
      <Form.Group
        className="d-flex align-items-center gap-2"
        controlId="row-per-page"
      >
        <Form.Label className="m-0">Rows per page:</Form.Label>
        <Form.Select
          value={pageSize}
          onChange={(e) => {
            const next = Number(e.target.value);
            setPageSize(next);
            setCurrentPage(1);
          }}
          style={{ width: 80 }}
          disabled={loading}
          className="cursor-pointer"
        >
          {perPageOptions?.map((item, i) => (
            <option value={item} key={i}>
              {item}
            </option>
          ))}
          {/* <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option> */}
        </Form.Select>
      </Form.Group>

      <div className="text-center text-muted">
        {total === 0 ? "0" : `${startIndex}-${endIndex}`} of {total}
      </div>

      <div className="d-flex justify-content-md-end justify-content-start">
        <Pagination className="mb-0 custom-pagination">
          <Pagination.Prev
            disabled={currentPage === 1 || loading}
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          />
          {pageItems}
          <Pagination.Next
            disabled={currentPage === totalPages || loading}
            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          />
        </Pagination>
      </div>
    </div>
  );
};

export default CustomPagination;
